import logo from "./logo.svg";
import "./App.css";
import appStore from "./appStore.svg";

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>GitStreak</h1>
        <a href="mailto:app.gitstreak@gmail.com" style={{ color: "white" }}>
          Contact us
        </a>
        <a
          href="https://apps.apple.com/app/gitstreak/id1563289883"
          style={{ marginTop: "6vh", marginBottom: "6vh" }}
        >
          <img src={appStore} className="App-store" alt="appStore" />
        </a>
      </header>
    </div>
  );
}

export default Home;
